import { ApiOperationBase, ApiReinvestmentConfirmationInstruction } from 'api/rtk-api'
import { PresentationalTable } from 'components/core-v2'

interface Props {
  operation: ApiOperationBase
}
export const ReinvestmentTable = ({ operation }: Props) => {
  const { assetId, exDate, reinvestmentDate, shares } =
    operation.associatedInstruction as ApiReinvestmentConfirmationInstruction
  return (
    <PresentationalTable
      headerRow={['Asset ID', 'Exe. Date', 'Reinvestment Date', 'Units']}
      rowOptions={[
        { width: '25%' },
        { width: '25%' },
        { width: '25%' },
        { width: '25%', align: 'right' }
      ]}
      rows={[[assetId, exDate, reinvestmentDate, shares]]}
    />
  )
}
